import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-background',
  imports: [CommonModule],
  templateUrl: './background.html',
  styleUrl: './background.scss'
})
export class Background {

  @Input() backgroundImage!: string;

  get style() {
    return {
      'background-image': `url('${this.backgroundImage}')`,
    }
  }
}
